import {
  assert_is_safe_number,
  assert_string_hash_sha256,
  assert_string_object_id,
  assert_type_boolean,
  assert_type_string,
} from '@shared/asserts/utils_asserts';
import { assert_string_uuid_not_empty } from '@shared/asserts/utils_asserts_string';
import { DTO__base } from '@shared/common/DTO__base';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ERROR_GRAPH__base } from '../../_errors/ERROR_GRAPH__base';

export class DTO_META__invocation_info extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_META;

  /*
   * FIELDS
   */

  graph_id!: string;

  node_id!: string;
  node_hash!: string;
  node_role!: string;

  use_cache!: boolean; //todo:remove

  is_deletable!: boolean;
  is_connected_to_grid2d!: boolean;

  show_hidden_fields!: boolean;

  graph_x_px!: number; //in px
  graph_y_px!: number; //in px

  // cells amount
  // fixed
  graph_width!: number; //in cells

  //cells amount
  // value = inputs + outputs count
  graph_height!: number; //in cells

  is_validated!: boolean;
  errors!: ERROR_GRAPH__base[];

  added_at!: number;

  /*
   * PROPERTIES
   */
  get graph_width_px() {
    return this.graph_width * CONSTANTS__shared.GRID_CELL_SIZE; //w-6 or h-6
  }

  get graph_height_px() {
    return this.graph_height * CONSTANTS__shared.GRID_CELL_SIZE; //w-6 or h-6
  }

  /*
   * METHODS
   */

  constructor() {
    super();

    this.show_hidden_fields = false;
    this.is_connected_to_grid2d = false;

    this.errors_clear();

    this.node_hash = ENUM__string_id_empty.HASH_SHA256;
  }

  is_intersects_with(other: DTO_META__invocation_info): boolean {
    let { GRAPH_GRID_NODES_GAP_X, GRAPH_GRID_NODES_GAP_Y, GRID_CELL_SIZE } = CONSTANTS__shared;

    const gap_horizontal = GRID_CELL_SIZE * GRAPH_GRID_NODES_GAP_X;
    const gap_vertical = GRID_CELL_SIZE * GRAPH_GRID_NODES_GAP_Y;

    const a_left = this.graph_x_px - gap_horizontal;
    const a_right = this.graph_x_px + this.graph_width_px + gap_horizontal;

    const a_top = this.graph_y_px - gap_vertical;
    const a_bottom = this.graph_y_px + this.graph_height_px + gap_vertical;

    const b_left = other.graph_x_px - gap_horizontal;
    const b_right = other.graph_x_px + other.graph_width_px + gap_horizontal;

    const b_top = other.graph_y_px - gap_vertical;
    const b_bottom = other.graph_y_px + other.graph_height_px + gap_vertical;

    return a_left < b_right && a_right > b_left && a_top < b_bottom && a_bottom > b_top;
  }

  create_id() {
    this.node_id = crypto.randomUUID();
  }

  errors_clear() {
    this.errors = [];
    this.is_validated = false;
  }

  assert_standard_fields(): void {
    assert_string_object_id(this.graph_id);
    assert_string_uuid_not_empty(this.node_id);

    assert_string_hash_sha256(this.node_hash);
    assert_type_string(this.node_role);

    assert_type_boolean(this.use_cache);
    assert_type_boolean(this.is_deletable);
    assert_type_boolean(this.is_connected_to_grid2d);

    assert_type_boolean(this.show_hidden_fields);

    assert_is_safe_number(this.graph_x_px);
    assert_is_safe_number(this.graph_y_px);

    assert_is_safe_number(this.graph_width);
    assert_is_safe_number(this.graph_height);

    assert_type_boolean(this.is_validated);

    assert_is_safe_number(this.added_at);
  }
}
